import { Button, CheckBox, Form, Popup, TextArea, TextBox } from 'devextreme-react';
import { ButtonItem, EmptyItem, Label, SimpleItem } from 'devextreme-react/form';
import { SelectBox, Item as SbItem } from 'devextreme-react/select-box';
import { Component } from 'react';
import DataGateProps from './DataGateProps';

class ComplexInputFieldProps extends Component {
    state = {
        field: this.props.complexInputField ?? {},
    }

    set = updater => {
        updater(this.state.field);
        this.forceUpdate();
    }

    render() {
        // (base)row, its columns or fields =>
        // type => this.props.type: {children or relateds} UniGrid or tabs containing unigrids, (Sub)Form, MultiSelectGrid, List
        // onValueChanged, loadApi, saveApi =>
        // readOnly, visible
        return (
            <>
                <Form rtlEnabled colCount={60} width='50rem'
                >
                    <SimpleItem colSpan={30}>
                        <Label text='نوع' />
                        <SelectBox rtlEnabled={false} className='mdh-left-align'
                            displayExpr='text' valueExpr='type' // enum FormFieldSetting.Types      
                            value={this.state.field.type} onValueChanged={e => this.set(f => f.type = e.value)}
                        >
                            <SbItem type={4} text={'Grid'} />
                            <SbItem type={5} text={'Single Select'} />
                            <SbItem type={6} text={'Multi Select'} />
                            <SbItem type={7} text={'Form'} />
                        </SelectBox>
                    </SimpleItem>

                    <SimpleItem colSpan={30}  >
                        <Label text='نام' />
                        <TextBox rtlEnabled value={this.state.field.name} onValueChanged={e => this.set(f => f.name = e.value)}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={30}  >
                        <Label text='توضیح' />
                        <TextBox rtlEnabled value={this.state.field.dsc} onValueChanged={e => this.set(f => f.dsc = e.value)}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30}>
                        <Label text='راهنمایی' />
                        <TextBox rtlEnabled value={this.state.field.hint} onValueChanged={e => this.set(f => f.hint = e.value)}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30}>
                        <Label text='عنوان فارسی' />
                        <TextBox rtlEnabled value={this.state.field.caption_FA} onValueChanged={e => this.set(f => f.caption_FA = e.value)}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30}>
                        <Label text='عنوان انگلیسی' />
                        <TextBox rtlEnabled={false} className='mdh-left-align'
                            value={this.state.field.caption_EN} onValueChanged={e => this.set(f => f.caption_EN = e.value)}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30}>
                        <Label text='عنوان عربی' />
                        <TextBox rtlEnabled value={this.state.field.caption_AR} onValueChanged={e => this.set(f => f.caption_AR = e.value)}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30}>
                        <Label text='دروازه داده' />
                        <Button text='انتخاب ...' onClick={() => this.setState({ dataGatePopVisible: true })} width='100%'
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30}>
                        <Label text='فقط خواندنی' />
                        <CheckBox rtlEnabled value={this.state.field.isReadOnly === true} onValueChanged={e => this.set(f => f.isReadOnly = e.value === true)}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30}>
                        <Label text='استایل' />
                        <TextArea rtlEnabled={false} className='mdh-left-align'
                            value={this.state.field?.jsStyle} minHeight='3rem'
                        />
                    </SimpleItem>

                    <EmptyItem colSpan={60} />

                    <ButtonItem colSpan={15} buttonOptions={{
                        text: 'قبول', icon: 'check', width: '90%', type: 'success',
                        onClick: () => this.props.onOk(this.state.field)
                    }}
                    />

                    <ButtonItem colSpan={15} buttonOptions={{
                        text: 'رد', icon: 'close', width: '90%', type: 'danger',
                        onClick: () => this.props.onCancel()
                    }}
                    />
                </Form>

                <Popup title='دروازه داده' visible={this.state.dataGatePopVisible} showCloseButton rtlEnabled
                    width='auto' height='auto'
                    onHidden={() => this.setState({ dataGatePopVisible: false })}
                >
                    <DataGateProps dataGate={JSON.parse(this.state.field?.rowDataGateJsn ?? '{}')}
                        onOk={dataGate => {
                            this.setState({
                                field: { ...this.state.field, rowDataGateJsn: JSON.stringify(dataGate) },
                                dataGatePopVisible: false
                            });
                        }}
                        onCancel={() => this.setState({ dataGatePopVisible: false })}
                    />
                </Popup>
            </>
        );
    }
}

export default ComplexInputFieldProps;
